export {
  default as wifi,
  ReactComponent as Wifi,
} from '@assets/icons/features-and-amenities/wifi.svg'    
